import React from 'react';
import { get } from 'lodash-es';
import PropTypes from 'prop-types';
/* Models */
import { DealerInfoEntities } from 'client/data/models/dealer-info';
import { InventoryEntities } from 'client/data/models/inventory';
/* Utils */
import { srpLinkBuilder } from 'site-modules/shared/utils/srp-link-constructor';
import { updateCreativeId } from 'site-modules/financing/utils/update-creative-id';
/* Constants */
import { APPROVED_VEHICLE_NOT_FOUND_COPY } from 'site-modules/shared/constants/financing/texts';
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';
/* Components */
import { ConfirmationContainer } from 'site-modules/financing/components/shared/confirmation-container/confirmation-container';

export function VehicleNotFoundScreenError({ vehicle = {}, dealerInfo = {}, isMatchingVIN = false }) {
  const rooftopId = get(vehicle, 'dealerInfo.rooftopId', get(dealerInfo, 'rooftopId'));
  return (
    <div data-tracking-parent={updateCreativeId({ isMatchingVIN, trackingParent: 'approved_vehicle_not_found' })}>
      <ConfirmationContainer
        link={srpLinkBuilder({
          dealerlocationid: rooftopId,
          inventorytype: `${INVENTORY_TYPES_LOWERCASE.USED},${INVENTORY_TYPES_LOWERCASE.CPO}`,
        })}
        copy={APPROVED_VEHICLE_NOT_FOUND_COPY}
        isError
      />
    </div>
  );
}
VehicleNotFoundScreenError.propTypes = {
  isMatchingVIN: PropTypes.bool,
  vehicle: InventoryEntities.InventoryVin,
  dealerInfo: DealerInfoEntities.DealerInfo,
};
